import { render, staticRenderFns } from "./EditorDescription.vue?vue&type=template&id=e019283c&scoped=true&"
import script from "./EditorDescription.vue?vue&type=script&lang=ts&"
export * from "./EditorDescription.vue?vue&type=script&lang=ts&"
import style0 from "./EditorDescription.vue?vue&type=style&index=0&id=e019283c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e019283c",
  null
  
)

export default component.exports